// extracted by mini-css-extract-plugin
export default {"header":"styles_header__zIKpe","column":"styles_column__tS4z7"};